
export interface Equipment {
    id: string;
    stockNumber: string;
    name: string;
    category: string;
    vin: string;
    year: number;
    make: string;
    model: string;
    series: string;
    fuelType: string;
    engineManufacturer: string;
    engineModel: string;
    engineHP: number;
    engineCylinders: number;
    engineLiters: number;
    transmission: string;
    transmissionManufacturer: string;
    driveType: string;
    numberRearAxles: number;
    suspension: string;
    rearAxle: string;
    rearEndRatio: string;
    brakeType: string;
    gvwr: number;
    gvwrClass: number;
    bedDimensions: string;
    wheelBase: number;
    odometer: number;
    price: number;
    comments: string;
    frontTireSize: string;
    rearTireSize: string;
    video_url: string;

    // Internal
    order: number;
    status: EquipmentStatus;

    //image
    imageUrl: string;

    // Posting
    commercialTruckTrader: boolean;
}

export function getEquipmentUrl(item: Equipment) {
    const name = item.name
        .replace(/-/g, '_')
        .replace(/ /g, '-');

    const stockNumber = item.stockNumber
        .replace(/-/g, '-')
        .replace(/ /g, '-');
    return [stockNumber, name]
        .join('--');
}

export function getEngineName(item: Equipment): string {
    return [item.engineManufacturer, item.engineModel, item.engineLiters]
        .join(' ');
}

export function getStockNumberFromUri(name: string) {
    return name.split('--')[0]
        .replace(/-/g, ' ')
        .replace(/_/g, '-');
}

export function textTruncate( str: string, length = 100, ending= '...') {
    if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    } else {
        return str;
    }
}

export enum EquipmentStatus {
    Hidden = 0,
    Visible = 1,
    Archived = 2
}

export interface EquipmentImage {
    id: string;
    public_id: string;
    order: number;
    url: string;
    height: number;
    width: number;
    bytes: number;
}